
import Vue, { PropType } from 'vue'
import { Gateway, GatewayStatus } from '@/models'
import moment from 'moment'

export default Vue.extend({
  name: 'GatewayListItem',

  props: {
    gateway: Object as PropType<Gateway>
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    },

    statusText(): string {
      switch (this.gateway?.details?.status) {
        case GatewayStatus.UNINITIALIZED:
          return '未初期化'
        case GatewayStatus.RUNNING:
          return '稼動'
        case GatewayStatus.SUSPENDED:
          return '停止'
        default:
          return '不明'
      }
    },

    statusTextClass(): string {
      return [
        GatewayStatus.UNKNOWNGATEWAYSTATUS,
        GatewayStatus.UNINITIALIZED,
        GatewayStatus.SUSPENDED,
      ].includes(this.gateway?.details?.status || GatewayStatus.UNKNOWNGATEWAYSTATUS) ? 'red' : ''
    },

    checkedTimingText(): string {
      if (!this.gateway?.details?.statusUpdatedTime) return 'なし'
      return moment(this.gateway?.details?.statusUpdatedTime).format('YYYY-MM-DD(HH:mm:ss)')
    },

    deletable(): boolean {
      return this.gateway?.details?.status !== GatewayStatus.RUNNING
    },

    deleteButtonClassText(): string {
      return this.deletable ? 'hover-circle' : 'disabled'
    }
  },

  methods: {
    showDeleteScreen(): void {
      if (!this.deletable) {
        return
      }
      const companyId = this.$auth.companyId
      const gatewayId = this.gateway.id
      if (!companyId || !gatewayId) {
        return
      }
      this.$router.push({
        name: 'admin-company-gateway-delete',
        params: {
          companyId: companyId,
          gatewayId: gatewayId
        }
      })
    }
  }
})
